/**
 * bundle-cart-rewards.js — mini-cart spend-reward bar (ticked checkpoints).
 *
 * The bar tracks ONE number: the whole-cart subtotal. Which items a reward
 * actually APPLIES to (the % skips pre-made bundles / sale items; free
 * shipping covers everything) is told per line by the saving chips and the
 * receipt, which read Shopify's real allocations.
 *
 * State comes from the DOM: snippets/cart-receipt.liquid re-renders a hidden
 * [data-cart-live] element (total / tiers) inside [data-cart-price-holder] on
 * every cart change, so no /cart.js polling. Also toggles the receipt's
 * free-shipping row ([data-receipt-ship]) — done here rather than in Liquid so
 * the threshold compares in the buyer's currency.
 * Requires window.theme.bundleTiers (bundle-tiers.js).
 */
(function () {
  'use strict';

  const CHECK = '<svg class="cart__rewards__ck" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12.5l5 5L20 6.5"/></svg>';

  function readState() {
    const lives = document.querySelectorAll('[data-cart-live]');
    const live = lives.length ? lives[lives.length - 1] : null;
    if (live) {
      return {
        total: parseInt(live.getAttribute('data-total'), 10) || 0,
        tiersRaw: live.getAttribute('data-tiers')
      };
    }
    const bar = document.querySelector('[data-cart-rewards]');
    if (bar) {
      return {
        total: parseInt(bar.getAttribute('data-subtotal'), 10) || 0,
        tiersRaw: bar.getAttribute('data-tiers')
      };
    }
    return null;
  }

  // One continuous track with a checkpoint dot per tier ("ticked checkpoints"):
  // reached dots become a check, the next tier is ringed, $ labels sit underneath.
  function buildTicks(bar, BT, tiers) {
    const wrap = bar.querySelector('[data-cart-rewards-segs]');
    if (!wrap || wrap.children.length) return;
    const topMin = tiers[tiers.length - 1].min;
    const track = document.createElement('div');
    track.className = 'cart__rewards__track';
    track.innerHTML = '<div class="cart__rewards__fill" data-rw-fill></div>' +
      '<div class="cart__rewards__ticks">' +
      tiers.map((t) =>
        '<div class="cart__rewards__tick" data-rw-tick data-min="' + t.min + '" style="left:' + ((t.min / topMin) * 100) + '%">' +
          '<span class="cart__rewards__dot">' + CHECK + '</span>' +
          '<span class="cart__rewards__lbl">' + BT.formatMoneyShort(t.min) + '</span>' +
        '</div>'
      ).join('') +
      '</div>';
    wrap.appendChild(track);
  }

  function render(bar, BT, state, tiers, sig) {
    if (!tiers.length) return;
    if (bar.getAttribute('data-rewards-sig') === sig) return;
    bar.setAttribute('data-rewards-sig', sig);

    buildTicks(bar, BT, tiers);

    const topMin = tiers[tiers.length - 1].min;
    let next = null;
    for (let i = 0; i < tiers.length; i++) {
      if (state.total < tiers[i].min) { next = tiers[i]; break; }
    }

    const fill = bar.querySelector('[data-rw-fill]');
    if (fill) fill.style.width = Math.min(100, (state.total / topMin) * 100) + '%';

    bar.querySelectorAll('[data-rw-tick]').forEach((tick, i) => {
      const tier = tiers[i];
      if (!tier) return;
      tick.classList.toggle('is-reached', state.total >= tier.min);
      tick.classList.toggle('is-next', next !== null && tier.min === next.min);
    });

    const msg = bar.querySelector('[data-cart-rewards-message]');
    if (msg) {
      if (next) {
        msg.innerHTML = 'Spend <span class="cart__rewards__amt">' + BT.formatMoneyShort(next.min - state.total) +
          '</span> more for <span class="cart__rewards__rw">' + BT.describeReward(next) + '</span>';
      } else {
        msg.innerHTML = '<span class="cart__rewards__ok">' + CHECK + '</span> <span class="cart__rewards__rw">' +
          BT.describeReward(tiers[tiers.length - 1]) + '</span> unlocked';
      }
    }
  }

  function toggleShipRows(state, tiers) {
    const ship = tiers.find((t) => t.free_shipping && t.min > 0);
    document.querySelectorAll('[data-receipt-ship]').forEach((row) => {
      row.hidden = !(ship && state.total >= ship.min);
    });
  }

  function paint() {
    const BT = window.theme && window.theme.bundleTiers;
    if (!BT) return;
    const state = readState();
    if (!state) return;
    const tiers = BT.parseTiers(state.tiersRaw);
    if (!tiers.length) return;

    toggleShipRows(state, tiers);

    const sig = state.total + '|' + state.tiersRaw;
    document.querySelectorAll('[data-cart-rewards]').forEach((bar) => {
      render(bar, BT, state, tiers, sig);
    });
  }

  let debounceTimer = null;
  function schedulePaint() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(paint, 60);
  }

  document.addEventListener('theme:cart:loaded', schedulePaint);

  // The drawer body (bar included on first open, receipt on every update) is
  // cloned/replaced dynamically; the per-bar signature keeps repaints from looping.
  const drawer = document.getElementById('cart-drawer');
  if (drawer && window.MutationObserver) {
    new MutationObserver(schedulePaint).observe(drawer, { childList: true, subtree: true });
  }

  // /cart page: the price holder is swapped on quantity updates.
  document.querySelectorAll('.cart__aside [data-cart-price-holder]').forEach((holder) => {
    if (window.MutationObserver) new MutationObserver(schedulePaint).observe(holder, { childList: true });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paint);
  } else {
    paint();
  }
})();
